var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.429,
    height: 18,
    viewBox: "0 0 15.429 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "login",
    transform: "translate(-4.5 -2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2166",
    "data-name": "Path 2166",
    d: "M22.5,20.25H14.786A1.286,1.286,0,0,1,13.5,18.964V17.036h1.286v1.929H22.5V3.536H14.786V5.464H13.5V3.536A1.286,1.286,0,0,1,14.786,2.25H22.5a1.286,1.286,0,0,1,1.286,1.286V18.964A1.286,1.286,0,0,1,22.5,20.25Z",
    transform: "translate(-3.857 0)",
    fill: "#74613c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2167",
    "data-name": "Path 2167",
    d: "M11.308,18.058l2.3-2.308H4.5V14.464h9.109l-2.3-2.308.906-.906,3.857,3.857-3.857,3.857Z",
    transform: "translate(0 -3.857)",
    fill: "#74613c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.dce54649f2646f24116e2cdfc6e0981f.svg";
export { ForwardRef as ReactComponent };